import React, { useMemo, memo, useRef, useState, useEffect } from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { useSelector } from 'react-redux';

import { createData, createOptions } from './HorizontalBarsUtils';
import HorizontalBarsLabels from './HorizontalBarsLabels';
import NoChartsData from '../../no-charts-data/NoChartsData';
import VisitWebsiteContextMenu from '../../../visit-website-context-menu/VisitWebsiteContextMenu';

import scss from './HorizontalBars.module.scss';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

export const HORIZONTAL_BARS_CONTEXT_MENU = 'horizontal-bars/VisitWebsiteContextMenu';

const HorizontalBars = ({ data, dataKey, customTooltip }) => {
  const chartRef = useRef(null);
  const theme = useSelector((state) => state.global.theme);
  const [height, setHeight] = useState('500px');

  const options = useMemo(() => {
    return createOptions({ theme, customTooltip, data, dataKey });
  }, [theme, customTooltip, data, dataKey]);

  const chartData = useMemo(() => {
    return createData({ data, theme, dataKey });
  }, [data, theme, dataKey]);

  const handleContextMenu = (event) => {
    event.preventDefault();
  };

  useEffect(() => {
    if (chartData) {
      setHeight(chartData.datasets[0].data.length * 40 + 32 + 40 + 'px');
    }
  }, [chartData]);

  //fix tooltip on unmount
  useEffect(() => {
    return () => {
      const tooltip = document.getElementById('chartJsFancyColumnsNewTooltip');
      if (tooltip) {
        tooltip.remove();
      }
    };
  }, []);

  if (!data.length) {
    return <NoChartsData height='500px' />;
  }

  return (
    <div style={{ height, display: 'flex' }}>
      <HorizontalBarsLabels data={data} maxRows={2} />
      <Bar
        ref={chartRef}
        options={options}
        data={chartData}
        className={scss.barChart}
        onContextMenu={handleContextMenu}
      />
      <VisitWebsiteContextMenu id={HORIZONTAL_BARS_CONTEXT_MENU} />
    </div>
  );
};

export default memo(HorizontalBars);
